<template>

    <div class="row">
        <div class="col-sm-4 col-sm-offset-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Document toevoegen</h2>
                </div>
                <div class="box-body">
                    <p v-if="templates.length === 0">Er zijn geen templates gevonden waar je toegang toe hebt. Daarom is het nu niet mogelijk om een document toe te voegen aan dit project.</p>
                    <div v-else>
                        <div class="form-group">
                            <label for="template_id">Selecteer template</label>
                            <select name="template_id" id="template_id" class="form-control" v-model="form.template_uuid">
                                <option value="">-- Selecteer --</option>
                                <option v-for="template in templates" :value="template.uuid">{{ template.name }}</option>
                            </select>
                        </div>
                        <div class="form-group" v-show="selectedTemplate !== null && selectedTemplate.requires_subject === true">
                            <label for="template_id">Onderwerp</label>
                            <input type="text" name="subject" class="form-control" id="subject" v-model="form.subject" />
                        </div>
                        <div v-if="selectedTemplate !== null && selectedTemplate.files.length > 1" class="form-group">
                            <label for="file_id">Selecteer bestand om te gebruiken</label>
                            <select name="file_id" id="file_id" class="form-control" v-model="form.file_uuid">
                                <option value="">-- Selecteer --</option>
                                <option v-for="file in selectedTemplate.files" :value="file.uuid">{{ file.name }}</option>
                            </select>
                        </div>
                        <div v-show="selectedTemplate !== null" class="form-group">
                            <label for="contact">Contact</label>
                            <div class="input-group">
                                <input type="text" id="contact" class="form-control" disabled tabindex="1" :value="getContactValue" />
                                <span class="input-group-btn">
                                    <button class="btn btn-info btn-sm"
                                        @click="openCrmSelector"
                                        v-tooltip="'Contact zoeken'"
                                    >
                                        <i class="mdi mdi-account-search"></i>
                                    </button>
                                </span>
                            </div>
                            <crm-selector
                                ref="crmSelector"
                                :onSelected="storeContact"
                            ></crm-selector>
                        </div>
                        <div class="form-group text-right">
                            <button type="submit" class="btn btn-primary btn-sm" :disabled="!canSubmit" @click="onSubmit">Toevoegen</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import CrmSelector from "../Common/Selectors/CrmSelector";

export default {

    components:{
        CrmSelector
    },

    computed:{

        canSubmit(){
            return this.form.template_uuid !== '' &&
                (this.selectedTemplate.files.length <= 1 || this.form.file_uuid !== '') &&
                (this.selectedTemplate.requires_subject === false || this.form.subject !== '') &&
                this.selectedContact !== null &&
                this.posting === false;
        },

        getContactValue() {
            let contact = this.selectedContact;
            if (contact === null) {
                return '';
            }
            // Check if its a company
            if (!contact.isContact) {
                return contact.company_name;
            } else {
                if (contact.company_name === null || contact.company_name === "") {
                    return contact.full_name;
                } else {
                    return contact.full_name + " (" + contact.company_name + ")";
                }
            }
        },

        getPostData() {
            if (this.posting === false && !this.canSubmit) {
                return {};
            }
            return {
                module:"projects",
                template_uuid: this.form.template_uuid,
                file_uuid: this.form.file_uuid,
                subject: this.form.subject,
                crm_uuid: this.selectedContact.uuid,
            };
        },

        selectedTemplate() {
            if (this.form.template_uuid === '') {
                return null;
            }
            return this.templates.filter(template => template.uuid === this.form.template_uuid)[0];
        },

    },

    data() {
        return {
            form: {
                file_uuid:'',
                subject:'',
                template_uuid:'',
            },
            posting:false,
            selectedContact:null,
            templates:[],
        }
    },

    methods: {

        onSubmit() {
            if (!this.canSubmit) {
                return;
            }
            this.posting = true;
            axios.post(this.postUrl, this.getPostData)
            .then(resp => {
                this.$router.push({
                    name:'documents.show',
                    params:{
                        uuid:resp.data.data.document_uuid,
                    }
                });
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het aanmaken van het document"));
        },

        openCrmSelector() {
            this.$refs.crmSelector.openSelector();
        },

        storeContact(contact){
            this.selectedContact = contact;
            this.$refs.crmSelector.closeSelector();
        },

        getTemplates() {
            axios.get(this.route('api.v1.templates.list', false), {params:{module:"projects"}})
                .then(resp => this.templates = resp.data.data);
        },

    },

    mounted(){
        this.getTemplates();
    },

    props: {
        postUrl: { required:true },
    },

}

</script>
